module.exports = __webpack_public_path__ + "static/result-with-hand-mobile-af846c51aaff6615bd58e70dc7847e09.png";